import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { Bulto } from '@/__env/lib/Expedicion/Guias/Bultos';
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { Wait } from '@/__env/ext';

export class ControladorDeInicio extends ControladorBase
{
    public Bultos: Bulto[] = [];

    public async Iniciar()
    {
        this.Bultos.clear();
        this.Vista.Estado = 'iniciado';
        this.Vista.Modo = 'inicio';
        //await this.BuscarBulto( '7790387000849' );
    }

    protected Buscando: boolean = false;
    public async BuscarBulto( bul: string )
    {
        if ( this.Buscando )
            return;

        this.Buscando = true;
        await Wait( 50 );
        let b = await Bulto.create( bul );
        if ( b )
        {
            if ( this.Bultos.find( x => x.Id == b.Id ) )
            {
                this.Vista.Estado = 'iniciado';
            } else
            {
                this.Sonar( true );
                this.Bultos.push( b );
                this.Vista.Estado = 'iniciado';
            }


        } else
        {
            
            this.Vista.Estado = 'no-existe';
            await Wait( 1000 );
            this.Vista.Estado = 'iniciado';
        }
        this.Buscando = false;
    }

    public async Siguiente()
    {
        this.Sonar( true );
        this.Vista.Modo = 'finalizar';
    }

    public async Controlar( peso: number ): Promise<{ resultado: boolean, diferencia: number; }>
    {
        let pesototal = 0;
        for ( let ea of this.Bultos )
        {
            pesototal += ea.Peso;
        }

        console.log( this.Bultos.length, peso, pesototal );
        let res = await Bulto.Controlar( this.Bultos.map( x => x.Id ), peso, pesototal );
        
        if ( res.estado == 'controlado' )
        {
            this.Sonar( true );
            await Wait( 300 );
            this.Sonar( true );

            return { resultado: true, diferencia: peso - pesototal };
        }                               

        this.Sonar( false );
        return { resultado: false, diferencia: peso - pesototal };

    }

    public async Cancelar()
    {
        this.Iniciar();
    }

    public Sonar( r: boolean )
    {
        this._onSona.dispatch( r );

    }
    private _onSona = new SimpleEventDispatcher<boolean>();
    public get onSona() { return this._onSona.asEvent(); }


}